import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import AuthLayout from "views/layouts/AuthLayout";
import rocket from "assets/images/illustrations/rocket-white.png";
import ApiService from "services/ApiService";
import StorageService from "services/StorageService";
import ValidationService from "services/ValidationService";
import ToastUtils from "utils/ToastUtils";
import axios from "axios";

function Login() {
  const [rememberMe, setRememberMe] = useState(false);
  const [loginBtnDisabled, setLoginBtnDisabled] = useState(false);
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passError, setPassError] = useState(false);

  const navigate = useNavigate();

  const handleSetRememberMe = () => setRememberMe(!rememberMe);
  const handleSetEmail = (e) => {
    setEmail(e.target.value);
    setEmailError(false);
  };
  const handleSetPass = (e) => {
    setPass(e.target.value);
    setPassError(false);
  };

  const handlePassKeyDown = (e) => {
    if (e.key === "Enter") handleLogin();
  };

  const handleLogin = async () => {
    try {
      if (!areInputValid()) return;
      setLoginBtnDisabled(true);
      const payload = {
        email: email,
        password: pass,
      };

      const response = await axios.post(`${ApiService.baseUrl}/auth/token`, payload);
      setLoginBtnDisabled(false);

      StorageService.deleteUserEmail();
      if (rememberMe) StorageService.setUserEmail(email);

      StorageService.setData(response.data.accessToken);
      ApiService.refreshHeaders();
      navigate("/dashboard");
    } catch (error) {
      setLoginBtnDisabled(false);
      console.error(error);
      ToastUtils.error("Αδυναμία σύνδεσης!");
    }
  };

  const areInputValid = () => {
    let valid = true;
    if (!ValidationService.isValidEmail(email)) {
      valid = false;
      setEmailError(true);
    }

    if (pass === "") {
      valid = false;
      setPassError(true);
    }

    return valid;
  };

  useEffect(() => {
    StorageService.deleteData();
    const userEmail = StorageService.getUserEmail();
    if (!userEmail) return;
    setEmail(userEmail);
    setRememberMe(true);
  }, []);

  return (
    <AuthLayout
      title="Σύνδεση"
      description="Συμπληρώστε τα στοιχεία σας για να συνδεθείτε."
      illustration={{
        image: rocket,
        title: "Το ταξίδι στην ηλεκτρονική τιμολόγηση ξεκινάει εδώ!",
      }}
    >
      <SoftBox component="form" role="form">
        <SoftBox mb={2}>
          <SoftInput
            type="email"
            placeholder="Email"
            size="large"
            onChange={handleSetEmail}
            error={emailError}
            value={email}
          />
        </SoftBox>
        <SoftBox mb={2}>
          <SoftInput
            type="password"
            placeholder="Κωδικός"
            size="large"
            onChange={handleSetPass}
            onKeyDown={handlePassKeyDown}
            error={passError}
          />
        </SoftBox>
        <SoftBox display="flex" style={{ float: "right" }}>
          <SoftTypography
            component={Link}
            to="/forgot-password"
            variant="button"
            color="error"
            fontWeight="medium"
            textGradient
          >
            Ξεχάσατε τον κωδικό?
          </SoftTypography>
        </SoftBox>
        <SoftBox display="flex" alignItems="center">
          <Switch checked={rememberMe} onChange={handleSetRememberMe} />
          <SoftTypography
            variant="button"
            fontWeight="regular"
            onClick={handleSetRememberMe}
            sx={{ cursor: "pointer", userSelect: "none" }}
          >
            &nbsp;&nbsp;Απομνημόνευση Email
          </SoftTypography>
        </SoftBox>
        <SoftBox mt={4} mb={1}>
          <SoftButton
            variant="gradient"
            color="info"
            size="large"
            fullWidth
            onClick={handleLogin}
            disabled={loginBtnDisabled}
          >
            ΣΥΝΔΕΣΗ
          </SoftButton>
        </SoftBox>

        <SoftBox mt={3} textAlign="center">
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Δεν έχετε λογαριασμό?{" "}
            <SoftTypography
              component={Link}
              to="/register"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Εγγραφή
            </SoftTypography>
          </SoftTypography>
        </SoftBox>
      </SoftBox>
    </AuthLayout>
  );
}

export default Login;
